<template>
<el-dialog title="我的学员" :visible.sync="babyModalVisible" width="50%" :before-close="handleClose" v-loading="loading">
    <el-radio-group v-model="addType" style="margin:20px 0 40px 0;" v-if="babyForm.BabyID==''">
        <el-radio label="学号">通过学员的学号添加</el-radio>
        <el-radio label="新增">新增一个学员资料</el-radio>
    </el-radio-group>
    <!-- 通过学号新增 -->
    <el-form ref="idForm" label-position="left" :model="idForm" :rules="rules2" label-width="20%" v-if="addType=='学号'">
        <el-form-item label="学员学号" prop="BabyID">
            <el-input v-model="idForm.BabyID" autocomplete="off" placeholder="请填写学员的学号"></el-input>
        </el-form-item>
    </el-form>
    <!-- 填写资料新增 -->
    <el-form ref="babyForm" label-position="left" :model="babyForm" :rules="rules" label-width="20%" v-if="addType=='新增'">
        <el-form-item label="学员头像">
            <!-- <el-input v-model="babyForm.UserImg" autocomplete="off"></el-input> -->
            <el-image :src="ip + 'media/'+babyForm.UserImg" fit="cover" v-if="onRead"></el-image>
            <el-upload class="avatar-uploader" ref="upload" :data='uploadData' :action="ip+'users/upload'" :show-file-list="false"  :on-change="handleAvatarChange" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :auto-upload="false" v-if="!onRead">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <img v-if="!imageUrl&&!babyForm.UserImg" :src="imageUrl" class="avatar">
                <img v-if="!imageUrl&&babyForm.UserImg" :src="ip+'media/'+babyForm.UserImg" class="avatar">
                <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
        </el-form-item>
        <el-form-item label="学员姓名" prop="RealName">
            <el-input v-model="babyForm.RealName" autocomplete="off" :placeholder="onRead?'未填写':'请填写学员的姓名'" :disabled="onRead"></el-input>
        </el-form-item>
        <el-form-item label="学员昵称" prop="NikeName">
            <el-input v-model="babyForm.NikeName" autocomplete="off" :placeholder="onRead?'未填写':'请填写学员的昵称'" :disabled="onRead"></el-input>
        </el-form-item>
        <el-form-item label="学员性别">
            <el-radio-group v-model="babyForm.Sex" :disabled="onRead">
                <el-radio :label="0">女生</el-radio>
                <el-radio :label="1">男生</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="学员生日" prop="Birthday">
            <!-- <el-input v-model="babyForm.Birthday" autocomplete="off"></el-input> -->
            <el-date-picker v-model="babyForm.Birthday" type="date" :placeholder="onRead?'未填写':'请选择学员的生日'" :disabled="onRead"></el-date-picker>
        </el-form-item>
        <el-form-item label="学员所在年级" prop="SchoolGrade">
            <el-select v-model="babyForm.SchoolGrade" :placeholder="onRead?'未填写':'请选择学员所在年级'" :disabled="onRead">
                <el-option label="未入学" value="未入学"></el-option>
                <el-option label="幼儿园" value="幼儿园"></el-option>
                <el-option label="学前班" value="学前班"></el-option>
                <el-option label="小学" value="小学"></el-option>
                <el-option label="初中" value="初中"></el-option>
                <el-option label="高中" value="高中"></el-option>
                <el-option label="大学" value="大学"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="学员就读学校">
            <el-input v-model="babyForm.FromSchool" autocomplete="off" :placeholder="onRead?'未填写':'请填写学员就读学校'" :disabled="onRead"></el-input>
        </el-form-item>

    </el-form>
    <span slot="footer" class="dialog-footer" v-if="addType=='学号'">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submitBabyID('idForm')" v-track-event="{category:'通过学号添加学员', action:'click',opt_label:'PC弹窗页面'}">确 定</el-button>
    </span>
    <span slot="footer" class="dialog-footer" v-if="addType=='新增'">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submitForm('babyForm')" v-track-event="{category:'通过新增添加学员', action:'click',opt_label:'PC弹窗页面'}">确 定</el-button>
    </span>
</el-dialog>
</template>

<script>
// import imageConversion from 'image-conversion';
export default {
    data() {
        return {
            //加载框
            loading: false,
            //获取当前登录设备
            is_PC: this.$store.state.is_PC,
            ip: this.$store.state.ip,
            //新增方式
            addType: "新增",
            //上传时的头像显示。
            imageUrl: '',
            //上传头像所带数据
            uploadData: {
                type: "media/BabyImg"
            },
            //是否上传过头像
            is_upload: false,
            //idForm
            idForm: {
                BabyID: '',
            },
            //表单验证规则
            rules: {
                RealName: [{
                    required: true,
                    message: '请输入学员的真实姓名',
                    trigger: 'blur'
                }],
                // NikeName: [{
                //     required: true,
                //     message: '请输入学员的昵称',
                //     trigger: 'blur'
                // }],
                // Birthday: [{
                //     required: true,
                //     message: '请输入学员的生日',
                //     trigger: 'blur'
                // }],
                // SchoolGrade: [{
                //     required: true,
                //     message: '请选择学员所在的年级',
                //     trigger: 'blur'
                // }],

            },
            rules2: {
                BabyID: [{
                    required: true,
                    message: '请输入学员的学号',
                    trigger: 'blur'
                }],
            }
        }
    },
    components: {

    },

    computed: {

        //学员资料弹窗
        babyModalVisible() {
            return this.$store.getters.get_babyModal_visible;
        },
        //学员资料弹窗
        babyForm() {
            if (this.$store.getters.get_babyModal_form.addbaby) {
                this.addType = '学号';
            } else {
                this.addType = '新增';
            }

            return this.$store.getters.get_babyModal_form;
        },
        //登录用户资料
        user() {
            if (this.$store.getters.get_login_user_data) {
                return this.$store.getters.get_login_user_data;
            } else {
                return JSON.parse(localStorage.getItem("user"));
            }
        },
        //是否只读
        onRead() {
            return !this.$store.getters.get_babyModal_form.onRead;
        }
    },

    created() {

    },
    mounted() {

    },
    methods: {
        //关闭弹窗
        handleClose() {
            this.$store.commit('update_babyModal_visible', false)
        },
        //图片上传成功后执行的函数
        handleAvatarSuccess(res, file) {
            //   this.imageUrl = URL.createObjectURL(file.raw);
            this.imageUrl = file.url;
            if (res.result === "OK") {
                this.babyForm.UserImg = res.msg
                // this.uploadReturnImgName = res.msg
            }
            if (this.babyForm.BabyID == '') {
                this.addBabyData();
            } else {
                this.updateBabyData();
            }
        },
        //图片选择后执行的函数
        handleAvatarChange(file, fileList) {
            //  
            
            if (fileList.length >= 2) {
                fileList.length = 0;
                fileList.push(file)
            }
            // console.log(fileList)
            this.imageUrl = URL.createObjectURL(file.raw);
            this.is_upload = true
        },

        beforeAvatarUpload(file) {
            return new Promise((resolve, reject) => {
                let isLt2M = file.size / 1024 / 1024 < 2 // 判定图片大小是否小于2MB
                if (isLt2M) {
                    resolve(file)
                }
                // 压缩到800KB,这里的800就是要压缩的大小,可自定义
                // imageConversion.compressAccurately(file, 800).then(res => {
                //     // console.log(res)
                //     resolve(res)
                // })
            })
        },
        //取消按钮
        cancel() {
            this.$store.commit('update_babyModal_visible', false);
            this.is_upload = false;
            this.imageUrl = '';
        },

        //确定按钮//提交表单
        submitForm(babyForm) {
            if (!this.onRead) {
                this.$refs[babyForm].validate((valid) => {
                    if (valid) {
                        if (this.is_upload) {
                            this.$refs.upload.submit();
                            this.is_upload = false;
                        } else {
                            if (this.babyForm.BabyID == '') {
                                this.addBabyData();
                            } else {
                                this.updateBabyData();
                            }

                        }
                    } else {
                        return false;
                    }
                });
            } else {
                this.$store.commit('update_babyModal_visible', false);
            }

        },
        //学号添加验证按钮
        submitBabyID(babyForm) {
            this.$refs[babyForm].validate((valid) => {
                if (valid) {
                    this.bindBabyData();
                } else {
                    return false;
                }
            });
        },

        //修改学员资料
        updateBabyData() {
            //打开loding
            this.loading = true;
            let that = this;
            let UserImg, NikeName, RealName, Sex, Birthday, SchoolGrade, FromSchool, BabyID
            // 获取更改后的资料,
            BabyID = this.babyForm.BabyID;
            UserImg = this.babyForm.UserImg;
            NikeName = this.babyForm.NikeName;
            RealName = this.babyForm.RealName;
            Sex = this.babyForm.Sex;
            Birthday = this.babyForm.Birthday;
            SchoolGrade = this.babyForm.SchoolGrade;
            FromSchool = this.babyForm.FromSchool;
            //获取传入data
            let params = {
                UserImg,
                BabyID,
                NikeName,
                RealName,
                Sex,
                Birthday,
                SchoolGrade,
                FromSchool,
            }
            this.$store.dispatch('updateBabyData', params).then((response) => {
                let res = response;
                // console.log(response)
                if (res.statusText === 'OK') {
                    //关闭loding
                    this.loading = false;
                    //更新后的资料存到localStorage缓存区
                    // localStorage.setItem("user", JSON.stringify(res.data));
                    //同时更新后的资料存到Vuex
                    // that.$store.commit('update_babyModal_form', res.data);
                    that.getUserData();
                    //弹窗提示修改成功，刷新页面
                    this.$alert('资料修改成功', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                            
                            // window.reload();
                            this.imageUrl = '';
                            this.$store.commit('update_babyModal_visible', false)
                        }
                    });
                } else {
                    // alert("网络错误")
                    //关闭loding
                    this.loading = false;
                    this.$message.error(res.detail);
                }
            }).catch(err => {
                //关闭loding
                this.loading = false;
                console.error(err);
                this.$message.error("您当前网络有问题，请稍后再试。");
            });
        },
        //新增学员资料
        addBabyData() {
            //打开loding
            this.loading = true;
            let that = this;
            let UserImg, NikeName, RealName, Sex, Birthday, SchoolGrade, FromSchool, UserID
            // 获取更改后的资料,
            UserID = this.user.UserID;
            UserImg = this.babyForm.UserImg;
            NikeName = this.babyForm.NikeName;
            RealName = this.babyForm.RealName;
            Sex = this.babyForm.Sex;
            Birthday = this.babyForm.Birthday;
            SchoolGrade = this.babyForm.SchoolGrade;
            FromSchool = this.babyForm.FromSchool;
            //获取传入data
            let params = {
                UserImg,
                UserID,
                NikeName,
                RealName,
                Sex,
                Birthday,
                SchoolGrade,
                FromSchool,
            }
            this.$store.dispatch('addBabyData', params).then((response) => {
                let res = response;
                // console.log(response)
                if (res.statusText === 'Created') {
                    //关闭loding
                    this.loading = false;
                    //弹窗提示修改成功，刷新页面
                    this.$alert('学员新增成功', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                            // window.reload();
                            // this.$refs.babyForm.resetFields();
                            this.imageUrl = '';
                            this.$store.commit('update_babyModal_visible', false)
                        }
                    });
                    this.getUserData();
                } else {
                    //关闭loding
                    this.loading = false;
                    this.$message.error(res.detail);
                }
            }).catch(err => {
                //关闭loding
                this.loading = false;
                console.error(err);
                // this.$message.error("您当前网络有问题，请稍后再试。");
            });
        },
        //给用户绑定学员
        bindBabyData() {
            //打开loding
            this.loading = true;
            let that = this;
            let UserID = this.user.UserID;
            let BabyID = this.idForm.BabyID;
            let params = {
                UserID,
                BabyID
            };
            this.$store.dispatch('updateBabyData', params).then((response) => {
                let res = response;
                if (res.statusText === 'OK') {
                    //关闭loding
                    this.loading = false;
                    console.log(res.data)
                    //弹窗提示修改成功，刷新页面
                    this.$alert('学员绑定成功', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                            this.idForm.BabyID = '';
                            this.$store.commit('update_babyModal_visible', false)
                        }
                    });
                    this.getUserData();
                } else {
                    //关闭loding
                    this.loading = false;
                    this.$message.error(res.detail);
                }

            }).catch(err => {
                //关闭loding
                this.loading = false;
                console.error(err);
                this.$message.error("学员未找到，请核对学号后再试。");
            });
        },
        //获取用户资料更新用户资料
        getUserData() {
            let that = this;
            let UserID = this.user.UserID;
            let params = {
                UserID,
            };
            this.$store.dispatch('userData', params).then((response) => {
                let res = response;
                // console.log(response)
                if (res.statusText === 'OK') {
                    // console.log(res.data)
                    //更新后的资料存到localStorage缓存区
                    localStorage.setItem("user", JSON.stringify(res.data));
                    //同时更新后的资料存到Vuex
                    that.$store.commit('update_login_user', res.data);
                } else {
                    this.$message.error(res.detail);
                }
            }).catch(err => {
                console.error(err);
                // this.$message.error("您当前网络有问题，请稍后再试。");
            });
        },
    },
}
</script>

<style scoped>
.pc-content {
    margin-top: 180px;
}

.m-content {
    margin-top: 60px;
}

.el-image {
    border-radius: 50%;
    width: 80px;
    height: 80px;
    border: 2px solid #fff;
}

.avatar-uploader>>>.el-upload {
    border: 1px dashed #EBEEF5;
    border-radius: 50%;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: all .4s;
}

.avatar-uploader>>>.el-upload:hover {
    border-color: #57BC4C;
    transition: all .4s;
}

.avatar-uploader .avatar {
    transition: all .4s;
    opacity: 0.3;
}

.avatar-uploader>>>.el-upload:hover .avatar {
    opacity: 0.8;
    transition: all .4s;
}

.avatar-uploader>>>.el-upload:hover i {
    opacity: 0.3;
    transition: all .4s;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #57bc4c;
    /* width: 120px;
    height: 120px; */
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    position: absolute;
}

.avatar {
    width: 120px;
    height: 120px;
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/modal/babyModal.vue